import React, { useEffect, useMemo, useState } from "react";
import {
  Avatar,
  Box,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Dialog,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import {
  useCreatePolicyMutation,
  useGetCustomerQuery,
  useGetLimitOneCustomerQuery,
  useGetAllMainCategoryQuery,
  useGetSubCategoryByArrayQuery,
  useGetProductQuery,
  useGetAllPolicyGroupByEmptyQuery,
  useGetProductBrandQuery,
  useGetAllCategoryNameQuery,
  useGetCustomerRelationQuery,
  useGetAllByPolicyNumberCountQuery,
} from "../../../Api/attoDeskApi";
import {
  ICategory,
  ICustomer,
  ICustomerRelative2,
  IPolicy,
  IProductBrand,
  IProductPopUP,
  policyCBArray,
  policyTermsArray,
  ICustomerRelative,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import { CiSearch } from "react-icons/ci";
import { useFormik } from "formik";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import NewPopUpProduct from "../../Customer/Edit/index";
import {
  Gender,
  MaritalStatus,
  PolicyCollectionType,
  RelationshipType,
  BenificeryType,
  widthofReactQuill,
} from "../../../Core/Enum/enum";
import { FaTrash } from "react-icons/fa";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import NewCategoryPopUp from "../../Category/Create/NewCategoryPopUp";
import NewProductBrand from "../../ProductBrand/Edit/index";
import NewProductPopUp from "../../Product/Create/newProductPopUp";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import Switch, { SwitchProps } from "@mui/material/Switch";
import AvatarImg from "../../../Images/avatar.png";
import Autocomplete from "@mui/material/Autocomplete";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { formatPhoneNumberForDisplaySpace } from "../../../Components/Validation/validationUtils";
import NewPopUpRelative from "../../Customer/Edit/relative";
import { BiSolidMessageSquareAdd } from "react-icons/bi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../Components/formatNumber/formatNumber";
import NewPopUpRelativeComponent from "../Relative/relative";
import NewPopUpRelativeInsuredComponent from "../Relative/insuredRelative";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import DeletePopup from "../../../Components/Delete/DeletePopup";

interface PolicyCustomerMember {
  customer: ICustomer;
  relationship: string;
}

function getPolicyCollectionType(policyPremiumFrequency: string) {
  switch (policyPremiumFrequency) {
    case PolicyCollectionType.OneTime:
      return "One Time";
    case PolicyCollectionType.Monthly:
      return "Monthly";
    case PolicyCollectionType.EveryTwoMonths:
      return "Every Two Months";
    case PolicyCollectionType.EveryThreeMonths:
      return "Every Three Months";
    case PolicyCollectionType.Quarterly:
      return "Quarterly";
    case PolicyCollectionType.SemiAnnually:
      return "Semi-Annually";
    case PolicyCollectionType.Annually:
      return "Annually";
    case PolicyCollectionType.Custom:
      return "Custom";
    default:
      return "";
  }
}

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 50,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(22px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.primary,
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "4px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 24,
    height: 24,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#757575" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 12,
      height: 12,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 8,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="12" width="12" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 8,
    },
  },
}));

const Index = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();

  // const { id: customerId } = useParams<{ id: string }>();

  const { customerId, coverageId } = useParams<{
    customerId: string;
    coverageId: string;
  }>();

  const { showErrorMessage, showMessage } = useNotifier();

  useEffect(() => {}, [customerId]);

  const { data, isLoading, isError } = useGetCustomerQuery({
    searchText: "",
    id: String(customerId),
  });

  const [openDialog, setOpenDialog] = useState(false);
  const [openDialogJoin, setOpenDialogJoin] = useState(false);
  const [openDialogCont, setOpenDialogCont] = useState(false);

  const [openDialogPB, setOpenDialogPB] = useState(false);
  const [openDialogCB, setOpenDialogCB] = useState(false);

  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCustomerNameCont, setSelectedCustomerNameCont] = useState("");

  const [openDialogAddProduct, setOpenDialogAddProduct] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  // const [selectedId, setSelectedId] = useState<number | null>(
  //   coverageId ? Number(coverageId) : null
  // );
  const [customerName, setCustomerName] = useState("");

  const [searchQuery, setSearchQuery] = useState("");
  // const [relationship, setRelationship] = useState<string>("");
  const [relationship, setRelationship] = useState<{ [key: string]: string }>(
    {}
  );

  const [resCustomerId, setResCustomerId] = useState<string>("");
  const [companyId, setCompanyId] = useState<string>("");

  const [addedCustomers, setAddedCustomers] = useState<PolicyCustomerMember[]>(
    []
  );

  const [selectedCoursing, setSelectedCoursing] = React.useState<ICustomer>();

  const [openCategory, setOpenCategory] = useState(false);
  const [openProductBrand, setOpenProductBrand] = useState(false);
  const [openProduct, setOpenProduct] = useState(false);

  const [showCategorySelection, setShowCategorySelection] = useState(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState<number[]>([]);
  const [openAddProject, setOpenAddProject] = useState(false);

  const { data: categoryNameData } = useGetAllCategoryNameQuery();

  const [currentTerm, setCurrentTerm] = useState<policyTermsArray[]>([]);
  const [policyCB, setpolicyCB] = useState<policyCBArray[]>([]);
  const [policyPB, setpolicyPB] = useState<policyCBArray[]>([]);
  const [resPolicyNumber, setPolicyNumber] = useState<string>("");

  const [openDeleteProject, setOpenDeleteProject] = useState(false);
  const [deleteconformationStatus, setDeleteConformStatus] =
    useState<string>("");
  const [deleteIndexNumber, setdeleteIndexNumber] = useState<number | null>(
    null
  );
  const [deleteconformationMessage, setDeleteConformMessage] =
    useState<string>("");
  const [deleteconformationTitile, setDeleteConformTitile] =
    useState<string>("");

  const {
    data: relativeData,
    isLoading: relativeIsLoading,
    isError: relativeError,
  } = useGetCustomerRelationQuery({
    policyCustomerId: String(customerId),
  });

  const { data: searchResults, isLoading: customerIsLoading } =
    useGetLimitOneCustomerQuery({
      searchText: searchQuery,
      id: resCustomerId || "",
      customerId: String(customerId),
    });

  const relativeList = useMemo(() => {
    return relativeData?.data as ICustomerRelative[];
  }, [relativeData?.data]);

  const {
    data: filterCustomerDataForAllData,
    isLoading: filterCustomerDataForAllIsLoading,
  } = useGetCustomerQuery({
    searchText: "",
    id: "",
  });

  const {
    data: countData,
    isLoading: countDataIsLoading,
    refetch: countRefetch,
    isError: countIsError,
  } = useGetAllByPolicyNumberCountQuery(
    {
      searchText: "",
      id: "",
      policyCustomerId: String(customerId),
      policyNumber: resPolicyNumber,
    },
    {
      skip: !resPolicyNumber || !customerId,
    }
  );

  const nextOrderNumber = Number(countData?.data || 0) + 1;

  const filterCustomerDataForAllDataList: ICustomer[] = Array.isArray(
    filterCustomerDataForAllData?.data
  )
    ? (filterCustomerDataForAllData?.data as ICustomer[])
    : [];

  const [newPolicy, { isLoading: dataIsLoading }] = useCreatePolicyMutation();

  const customer = useMemo(() => {
    if (data && Array.isArray(data.data) && data.data.length > 0) {
      return data.data[0] as ICustomer;
    }
    return null;
  }, [data]);

  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(
    null
  );
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubCategoryId, setSelectedSubToSubCategoryId] = useState<
    number | null
  >(null);

  const [selectedSubToSubToSubCategoryId, setSelectedSubToSubToSubCategoryId] =
    useState<number | null>(null);

  const { data: categoryData } = useGetAllMainCategoryQuery({
    departmentId: "",
    coursingId: "",
    roleId: null,
    taxeId: "",
    createdDateStart: null,
    createdDateEnd: null,
    searchText: "",
    numberOfLength: 0,
    isActive: true,
    categoryIsLooping: null,
    createdDate: null,
  });

  const { data: subCategoryData, refetch: refetchSubCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedCategoryId ? [Number(selectedCategoryId)] : [],
    });

  const { data: subCategory2Data, refetch: refetchS2bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [Number(selectedCategoryId), Number(selectedSubCategoryId)]
        : [],
    });

  const { data: subCategory3Data, refetch: refetchS3bCategories } =
    useGetSubCategoryByArrayQuery({
      parent_ids: selectedSubCategoryId
        ? [
            Number(selectedCategoryId),
            Number(selectedSubCategoryId),
            Number(selectedSubToSubCategoryId),
          ]
        : [],
    });

  const categoryGetAllList = useMemo(() => {
    return categoryNameData?.data as ICategory[];
  }, [categoryNameData?.data]);

  const coursingMap = useMemo(() => {
    const map = new Map();
    categoryGetAllList?.forEach((category) => {
      map.set(category.id, category.categoryName);
    });
    return map;
  }, [categoryGetAllList]);

  const categoryList = useMemo(() => {
    return categoryData?.data as ICategory[];
  }, [categoryData?.data]);

  const subCategoryList = useMemo(() => {
    return subCategoryData?.data as ICategory[];
  }, [subCategoryData?.data]);

  const subToSubCategoryList = useMemo(() => {
    return subCategory2Data?.data as ICategory[];
  }, [subCategory2Data?.data]);

  const subToSubToSubCategoryList = useMemo(() => {
    return subCategory3Data?.data as ICategory[];
  }, [subCategory3Data?.data]);

  const allCliendUpList = useMemo(() => {
    return (filterCustomerDataForAllData?.data ?? []) as ICustomer[];
  }, [filterCustomerDataForAllData?.data]);

  const cutomerMap = useMemo(() => {
    const map = new Map();
    allCliendUpList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [allCliendUpList]);

  const productCategoryId = selectedSubToSubToSubCategoryId
    ? Number(selectedSubToSubToSubCategoryId)
    : selectedSubToSubCategoryId
    ? Number(selectedSubToSubCategoryId)
    : selectedSubCategoryId
    ? Number(selectedSubCategoryId)
    : selectedCategoryId
    ? Number(selectedCategoryId)
    : String("");

  const {
    data: productData,
    isLoading: productDataIsLoading,
    isError: productDataError,
  } = useGetProductQuery({
    searchText: "",
    id: "",
    productBrandId: companyId,
    productCategoryId: String(productCategoryId),
    productTagIds: null,
    productViewOnline: null,
    createdDateStart: null,
    createdDateEnd: null,
    createdDate: null,
  });

  const { data: brandListData, isLoading: brandIsLoading } =
    useGetProductBrandQuery({
      searchText: "",
      isActive: true,
    });

  const {
    data: customerProjectData,
    isLoading: customerProjectDataIsLoading,
    refetch: cutomerProjectRefetch,
  } = useGetAllPolicyGroupByEmptyQuery({
    searchText: "",
    id: String(coverageId),
    policyCustomerId: String(customerId),
  });

  const productList = useMemo(() => {
    return productData?.data as IProductPopUP[];
  }, [productData?.data]);

  const brandList = useMemo(() => {
    return brandListData?.data as IProductBrand[];
  }, [brandListData?.data]);

  const relationDataList = useMemo(() => {
    return (relativeData?.data ?? []) as ICustomerRelative2[];
  }, [relativeData?.data]);

  const policyList: IPolicy[] = Array.isArray(customerProjectData?.data)
    ? (customerProjectData?.data as IPolicy[])
    : [];

  const brandMap = useMemo(() => {
    const map = new Map();
    brandList?.forEach((category) => {
      map.set(category.id, category.productBrandName);
    });
    return map;
  }, [brandList]);

  const relativeMap = useMemo(() => {
    const map = new Map();
    relationDataList?.forEach((item) => {
      map.set(
        item.id,
        `${toProperCase(item?.related_customer_name)} - ${
          item.relationship_type
        }`
      );
    });
    return map;
  }, [relationDataList]);

  const today = dayjs();

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleOpenDialogJoin = () => {
    setOpenDialogJoin(true);
  };

  const handleOpenDialogCont = () => {
    setOpenDialogCont(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSearchQuery("");
    // setRelationship("");
  };

  const handleOpenDialogPB = () => {
    setOpenDialogPB(true);
  };

  const handleCloseDialogPB = () => {
    setOpenDialogPB(false);
    setSearchQuery("");
  };

  const handleOpenDialogCB = () => {
    setOpenDialogCB(true);
  };

  const handleCloseDialogCB = () => {
    setOpenDialogCB(false);
    setSearchQuery("");
  };

  const handleCloseDialogJoin = () => {
    setOpenDialogJoin(false);
    setSearchQuery("");
  };

  const handleCloseDialoCont = () => {
    setOpenDialogCont(false);
    setSearchQuery("");
  };

  const handleOpenDialogRelative = () => {
    setOpenAddProject(true);
  };

  const handleCloseDialogRelative = () => {
    setOpenAddProject(false);
  };

  const handleSelectCustomer = (customer: ICustomerRelative) => {
    const id = customer.id;

    if (typeof id !== "number") return;

    setSelectedCustomerIds((prev) => {
      if (prev.includes(id)) return prev;
      return [...prev, id];
    });
  };

  const handleOpenDeleteProjectPopup = (
    idToRemove: number,
    status: string,
    name: string
  ) => {
    setOpenDeleteProject(true);
    setDeleteConformStatus(status);
    setdeleteIndexNumber(idToRemove);

    if (status === "insured") {
      setDeleteConformTitile("Delete Insured");
      setDeleteConformMessage(
        `Are you sure you want to delete insured ${name}?`
      );
    } else if (status === "pb") {
      setDeleteConformTitile("Delete Primary Beneficiaries");
      setDeleteConformMessage(
        `Are you sure you want to delete primary beneficiary ${name}?`
      );
    } else if (status === "cb") {
      setDeleteConformTitile("Delete Contingent Beneficiaries");
      setDeleteConformMessage(
        `Are you sure you want to delete contingent beneficiary ${name}?`
      );
    } else if (status === "terms") {
      setDeleteConformTitile("Delete Terms");
      setDeleteConformMessage(`Are you sure you want to delete term ${name}?`);
    }
  };

  const handleCloseDeleteProjectPopup = () => {
    setOpenDeleteProject(false);
    setdeleteIndexNumber(null);
    setDeleteConformMessage("");
    setDeleteConformTitile("");
  };

  const handleOpenDeleteConfirm = () => {
    if (deleteIndexNumber !== null && deleteconformationStatus) {
      if (deleteconformationStatus === "insured") {
        handleDeleteCustomer(deleteIndexNumber);
      } else if (deleteconformationStatus === "pb") {
        handleDeleteRowPB(deleteIndexNumber);
      } else if (deleteconformationStatus === "cb") {
        handleDeleteRowCB(deleteIndexNumber);
      } else if (deleteconformationStatus === "terms") {
        handleDeleteRow(deleteIndexNumber);
      }
      setOpenDeleteProject(false);
    }
  };

  const handleDeleteCustomer = (idToRemove: number) => {
    setSelectedCustomerIds((prev) => prev.filter((id) => id !== idToRemove));
  };

  const handleSelectCustomerPrimaryBenifi = (customer: ICustomerRelative) => {
    const id = customer.id;

    if (typeof id !== "number") return;

    setpolicyPB((prev) => [
      ...prev,
      {
        name: "",
        payoutPercentage: "",
        relationship: "",
        column1: id,
        column2: "",
      },
    ]);
  };

  const handleSelectCustomerConBenifi = (customer: ICustomerRelative) => {
    const id = customer.id;

    if (typeof id !== "number") return;

    setpolicyCB((prev) => [
      ...prev,
      {
        name: "",
        payoutPercentage: "",
        relationship: "",
        column1: id,
        column2: "",
      },
    ]);
  };

  const formik = useFormik({
    initialValues: {
      policyCustomerId: customerId,
      jointPolicyOwnerId: "",
      contengentPolicyOwnerId: "",
      policyNumber: "",
      policyCategoryId: null,
      mainCatId: null,
      policyInsuranceCompanyId: "",
      policyProductId: "",
      policyIssueDate: null,
      policyIsLifeTimeExpiryDate: false,
      policyExpiryDate: null,
      policyCoversionDate: null,
      policyRenewalDate: null,
      policyPaidUpDate: null,
      policyPayor: "",
      policyPremiumDetails: "",
      policyPremium: "",
      policyCoverageAmount: "",
      policyPremiumFrequency: "",
      policyDrawDay: "",
      policyInsuredDetails: [],
      policyPrimaryBenificaries: "",
      policyContengentBenificaries: "",
      policySummaryReportArray: [],
      policyOfficeUse: "",
      policyGtRefID: "",
      policyRemark: "",
      policyContengentBenificariesNew: [],
      policyPrimaryBenificariesNew: [],
      policyPremiumFrequencyDate: null,
      policyOrderNumber: null,
      coverageOrderNumber: nextOrderNumber,
      primaryPolicyId: "",
    },
    enableReinitialize: true,

    onSubmit: async (values, { resetForm }) => {
      try {
        const policyCategoryIdOff = (() => {
          const resolvedValue = selectedSubToSubToSubCategoryId
            ? Number(selectedSubToSubToSubCategoryId)
            : selectedSubToSubCategoryId
            ? Number(selectedSubToSubCategoryId)
            : selectedSubCategoryId
            ? Number(selectedSubCategoryId)
            : selectedCategoryId
            ? Number(selectedCategoryId)
            : Number(values.policyCategoryId);

          return resolvedValue === 0 ? null : resolvedValue;
        })();

        const resolvedPolicyCategoryId = selectedId
          ? Number(values.policyCategoryId)
          : policyCategoryIdOff;

        const temData = {
          policyCustomerId: values.policyCustomerId,
          contengentPolicyOwnerId: values.contengentPolicyOwnerId,
          jointPolicyOwnerId: values.jointPolicyOwnerId,
          policyNumber: values.policyNumber,
          policyCategoryId: policyCategoryIdOff,
          policyInsuranceCompanyId: values.policyInsuranceCompanyId,
          policyProductId: values.policyProductId,
          policyIssueDate: values.policyIssueDate,
          policyExpiryDate: values.policyExpiryDate,
          policyIsLifeTimeExpiryDate: values.policyIsLifeTimeExpiryDate,
          policyCoversionDate: values.policyCoversionDate,
          policyRenewalDate: values.policyRenewalDate,
          policyPaidUpDate: values.policyPaidUpDate,
          policyPayor: toProperCase(values.policyPayor),
          policyPremium: values.policyPremium
            ? String(values.policyPremium)
            : "",
          policyCoverageAmount: values.policyCoverageAmount
            ? String(values.policyCoverageAmount)
            : "",
          policyPremiumDetails: values.policyPremiumDetails
            ? String(values.policyPremiumDetails)
            : "",
          policyDrawDay: values.policyDrawDay,
          policyInsuredDetails: selectedCustomerIds,
          policyPrimaryBenificaries: values.policyPrimaryBenificaries,
          policyContengentBenificaries: values.policyContengentBenificaries,
          policySummaryReportArray: currentTerm,
          policyOfficeUse: values.policyOfficeUse,
          policyGtRefID: values.policyGtRefID,
          policyRemark: values.policyRemark,
          policyContengentBenificariesNew: policyCB,
          policyPrimaryBenificariesNew: policyPB,
          policyPremiumFrequencyDate: values.policyPremiumFrequencyDate,
          policyOrderNumber: values.policyOrderNumber,
          coverageOrderNumber: values.coverageOrderNumber,
          primaryPolicyId: values.primaryPolicyId,
        };

        const addCompanyResponse = await newPolicy(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          // navigate(`/profile/customer/${customerId}`);
          navigate(
            `/customer/${customerId}/policy/${addCompanyResponse.data.policyNumber}`
          );
          resetForm();
          setSelectedCategoryId(null);
          setSelectedSubCategoryId(null);
          setSelectedSubToSubCategoryId(null);
          setSelectedSubToSubToSubCategoryId(null);
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  useEffect(() => {
    if (coverageId) {
      const id = Number(coverageId);
      setSelectedId(id);

      // handleSelect(id);
    }
  }, [coverageId]);

  // const handleSelect = (companyId: number) => {
  //   setSelectedId(companyId);
  //   const selectedCompany = policyList.find(
  //     (company) => company.id === companyId
  //   );
  //   if (selectedCompany) {
  //     formik.setFieldValue("policyNumber", selectedCompany.policyNumber);
  //     formik.setFieldValue(
  //       "policyInsuranceCompanyId",
  //       selectedCompany.policyInsuranceCompanyId
  //     );
  //     formik.setFieldValue("policyProductId", selectedCompany.policyProductId);
  //     handleSelectCustomerJoinId(selectedCompany.jointPolicyOwnerId);
  //     // handleSelectCustomerContId(selectedCompany.contingentPolicyOwnerId);
  //     formik.setFieldValue("policyDrawDay", selectedCompany.policyDrawDay);
  //     formik.setFieldValue(
  //       "policyPremiumFrequency",
  //       selectedCompany.policyPremiumFrequency
  //     );
  //     formik.setFieldValue("policyPayor", selectedCompany.policyPayor);
  //     formik.setFieldValue(
  //       "policyCoverageAmount",
  //       selectedCompany.policyCoverageAmount
  //     );
  //     formik.setFieldValue(
  //       "policyCategoryId",
  //       selectedCompany.policyCategoryId
  //     );
  //     formik.setFieldValue("policyPremium", selectedCompany.policyPremium);
  //   }
  // };

  // useEffect(() => {
  //   if (coverageId) {
  //     setSelectedId(Number(coverageId));
  //   }
  // }, [coverageId]);

  // useEffect(() => {
  //   if (coverageId) {
  //     const companyId = Number(coverageId);
  //     setSelectedId(companyId);

  //     const selectedCompany = policyList.find(
  //       (company) => Number(company.id) === companyId
  //     );

  //     if (selectedCompany) {
  //       formik.setFieldValue("policyNumber", selectedCompany.policyNumber);
  //       formik.setFieldValue(
  //         "policyInsuranceCompanyId",
  //         selectedCompany.policyInsuranceCompanyId
  //       );
  //       formik.setFieldValue("policyProductId", selectedCompany.policyProductId);
  //       handleSelectCustomerJoinId(selectedCompany.jointPolicyOwnerId);
  //       handleSelectCustomerContId(selectedCompany.contengentPolicyOwnerId);
  //       formik.setFieldValue("policyDrawDay", selectedCompany.policyDrawDay);
  //       formik.setFieldValue(
  //         "policyPremiumFrequency",
  //         selectedCompany.policyPremiumFrequency
  //       );
  //       formik.setFieldValue("policyPayor", selectedCompany.policyPayor);
  //       formik.setFieldValue(
  //         "policyCoverageAmount",
  //         selectedCompany.policyCoverageAmount
  //       );
  //       formik.setFieldValue(
  //         "policyCategoryId",
  //         selectedCompany.policyCategoryId
  //       );
  //       formik.setFieldValue("policyPremium", selectedCompany.policyPremium);
  //     }
  //   }
  // }, [coverageId, policyList, formik]);

  useEffect(() => {
    if (coverageId) {
      const companyId = Number(coverageId);
      const selectedCompany = policyList.find(
        (company) => company.id === companyId
      );

      if (selectedCompany) {
        formik.setFieldValue("policyNumber", selectedCompany.policyNumber);
        formik.setFieldValue(
          "policyInsuranceCompanyId",
          selectedCompany.policyInsuranceCompanyId
        );
        formik.setFieldValue(
          "policyIssueDate",
          selectedCompany.policyIssueDate
        );
        // formik.setFieldValue(
        //   "policyProductId",
        //   selectedCompany.policyProductId
        // );
        handleSelectCustomerJoinId(selectedCompany.jointPolicyOwnerId);
        handleSelectCustomerContId(selectedCompany.contengentPolicyOwnerId);
        formik.setFieldValue("policyDrawDay", selectedCompany.policyDrawDay);
        formik.setFieldValue(
          "policyPremiumFrequency",
          selectedCompany.policyPremiumFrequency
        );
        formik.setFieldValue("policyPayor", selectedCompany.policyPayor);
        formik.setFieldValue(
          "policyCoverageAmount",
          selectedCompany.policyCoverageAmount
        );
        // formik.setFieldValue(
        //   "policyCategoryId",
        //   selectedCompany.policyCategoryId
        // );
        formik.setFieldValue("policyPremium", selectedCompany.policyPremium);
        formik.setFieldValue(
          "policyPremiumFrequencyDate",
          selectedCompany.policyPremiumFrequencyDate
        );
        formik.setFieldValue(
          "policyOrderNumber",
          selectedCompany.policyOrderNumber
        );
        formik.setFieldValue(
          "primaryPolicyId",
          selectedCompany.primaryPolicyId
        );
        // formik.setFieldValue(
        //   "coverageOrderNumber",
        //   selectedCompany.coverageOrderNumber
        // );
      }
    }
  }, [coverageId, policyList, resPolicyNumber]);

  useEffect(() => {
    setCompanyId(formik.values.policyInsuranceCompanyId || "");
  }, [formik.values.policyInsuranceCompanyId]);

  useEffect(() => {
    setPolicyNumber(formik.values.policyNumber);
  }, [formik.values.policyNumber]);

  const handleMainCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const categoryId = event.target.value as number;
    setSelectedCategoryId(categoryId);
    setSelectedSubCategoryId(null);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
    formik.setFieldValue("mainCatId", categoryId);
  };

  const handleSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const subCategoryId = event.target.value as number;
    setSelectedSubCategoryId(subCategoryId);
    setSelectedSubToSubCategoryId(null);
    setSelectedSubToSubToSubCategoryId(null);
  };

  const handleSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubCategoryId(selectedSubToSubCategoryId);
    setSelectedSubToSubToSubCategoryId(null);
  };

  const handleSubToSubToSubCategoryChange = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const selectedSubToSubToSubCategoryId = event.target.value as number;
    setSelectedSubToSubToSubCategoryId(selectedSubToSubToSubCategoryId);
  };

  const handleOpenDialogEdit = (coursing: ICustomer) => {
    setSelectedCoursing(coursing);
    setOpenDialogAddProduct(true);
  };

  const handleSelectCustomerJoin = (customer: ICustomer) => {
    formik.setFieldValue("jointPolicyOwnerId", customer.id);
    setSelectedCustomerName(
      `${toProperCase(customer.customerFirstName)} ${toProperCase(
        customer.customerLastName
      )}`
    );
    handleCloseDialogJoin();
  };

  const handleSelectCustomerCont = (customer: ICustomer) => {
    formik.setFieldValue("contengentPolicyOwnerId", customer.id);
    setSelectedCustomerNameCont(
      `${toProperCase(customer.customerFirstName)} ${toProperCase(
        customer.customerLastName
      )}`
    );
    handleCloseDialoCont();
  };

  const handleSelectCustomerJoinId = (customerId: number | null) => {
    if (customerId === null) {
      // Handle the null case here, such as clearing a field or setting a default value
      formik.setFieldValue("jointPolicyOwnerId", null);
      return;
    }

    // If customerId is not null, proceed with the rest of the logic
    const selectedCustomer = filterCustomerDataForAllDataList.find(
      (customer) => customer.id === customerId
    );

    if (selectedCustomer) {
      formik.setFieldValue("jointPolicyOwnerId", customerId);
      setSelectedCustomerName(
        `${selectedCustomer.customerFirstName} ${selectedCustomer.customerLastName}`
      );
    }
  };

  const handleSelectCustomerContId = (customerId: number | null) => {
    formik.setFieldValue("contengentPolicyOwnerId", customerId ?? null);

    if (customerId === null) {
      setSelectedCustomerNameCont("");
      return;
    }

    const selectedCustomer = filterCustomerDataForAllDataList.find(
      (customer) => customer.id === customerId
    );

    if (selectedCustomer) {
      setSelectedCustomerNameCont(
        `${selectedCustomer.customerFirstName} ${selectedCustomer.customerLastName}`
      );
    }
  };

  const handleShowCategorySelection = () => {
    setShowCategorySelection(true);
  };

  const handelColseFunction = () => {
    navigate(
      `/customer/${customerId}/policy/${formik.values.policyNumber || " "}`
    );
  };

  const handleAddRow = () => {
    setCurrentTerm((prev) => [
      ...prev,
      {
        id: null,
        policyTermsDescription: "",
        isPolicyTermsSummaryReport: true,
        isPolicyTermsAll: true,
        isPolicyTermsPrintPdf: true,
        termsOrderNumber: null,
      },
    ]);
  };

  const handleAddRowCB = () => {
    setpolicyCB((prev) => [
      ...prev,
      {
        name: "",
        payoutPercentage: "",
        relationship: "",
        column1: null,
        column2: "",
      },
    ]);
  };

  const handleAddRowPB = () => {
    setpolicyPB((prev) => [
      ...prev,
      {
        name: "",
        payoutPercentage: "",
        relationship: "",
        column1: null,
        column2: "",
      },
    ]);
  };

  // const handleFieldChange = <K extends keyof policyTermsArray>(
  //   index: number,
  //   field: K,
  //   value: policyTermsArray[K]
  // ) => {
  //   const updatedRows = currentTerm.map((term, i) => {
  //     if (i === index) {
  //       return {
  //         ...term,
  //         [field]: value !== undefined ? value : term[field],
  //       };
  //     }
  //     return term;
  //   });

  //   setCurrentTerm(updatedRows);
  // };

  const handleFieldChange = <K extends keyof policyTermsArray>(
    index: number,
    field: K,
    value: policyTermsArray[K]
  ) => {
    const updatedRows = currentTerm.map((term, i) => {
      if (i === index) {
        const updatedTerm = {
          ...term,
          [field]: value !== undefined ? value : term[field],
        };

        // If "All" is being turned on, set other switches to true
        if (field === "isPolicyTermsAll" && value === true) {
          updatedTerm.isPolicyTermsSummaryReport = true;
          updatedTerm.isPolicyTermsPrintPdf = true;
        }

        return updatedTerm;
      }
      return term;
    });

    setCurrentTerm(updatedRows);
  };

  console.log(currentTerm);
  const handleFieldChangeCB = <K extends keyof policyCBArray>(
    index: number,
    field: K,
    value: policyCBArray[K]
  ) => {
    const updatedRows = policyCB.map((term, i) => {
      if (i === index) {
        return {
          ...term,
          [field]: value !== undefined ? value : term[field],
        };
      }
      return term;
    });

    setpolicyCB(updatedRows);
  };

  const handleFieldChangePB = <K extends keyof policyCBArray>(
    index: number,
    field: K,
    value: policyCBArray[K]
  ) => {
    const updatedRows = policyPB.map((term, i) => {
      if (i === index) {
        return {
          ...term,
          [field]: value !== undefined ? value : term[field],
        };
      }
      return term;
    });

    setpolicyPB(updatedRows);
  };

  const handleDeleteRow = (index: number) => {
    const updatedRows = currentTerm.filter((_, i) => i !== index);
    setCurrentTerm(updatedRows);
  };

  const handleDeleteRowCB = (index: number) => {
    const updatedRows = policyCB.filter((_, i) => i !== index);
    setpolicyCB(updatedRows);
  };

  const handleDeleteRowPB = (index: number) => {
    const updatedRows = policyPB.filter((_, i) => i !== index);
    setpolicyPB(updatedRows);
  };

  const relatedCustomerIdMap = useMemo(() => {
    const map = new Map<number, number>();
    relationDataList?.forEach((item) => {
      if (item?.related_customer_id != null) {
        map.set(item.id, item.related_customer_id);
      }
    });
    return map;
  }, [relationDataList]);

  useEffect(() => {
    if (customer) {
      setCustomerName(
        `${customer.customerFirstName || ""} ${
          customer.customerLastName || ""
        }`.trim()
      );
    }
  }, [customer]);

  if (isLoading || customerProjectDataIsLoading || countDataIsLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error">
        Error fetching customer data. Please try again later.
      </Typography>
    );
  }

  if (!customer) {
    return <Typography>No customer data available.</Typography>;
  }

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={3}>
              {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Policy Holder Details
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} p={"24px"}>
                    <Grid item lg={8} md={12} sm={12} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item lg={4} md={4} sm={12} xs={12}>
                              <Typography variant="subtitle1">
                                Policy Holders Name
                              </Typography>
                            </Grid>
                            <Grid item lg={8} md={8} sm={12} xs={12}>
                              <TextField
                                placeholder="Enter First Name"
                                size="small"
                                value={
                                  toProperCase(
                                    customer.customerFirstName || ""
                                  ) +
                                  " " +
                                  toProperCase(customer.customerLastName || "")
                                }
                                className={classes.textField}
                                InputProps={{
                                  readOnly: true,
                                  // startAdornment: (
                                  //   <InputAdornment position= "end">
                                  //     <CiSearch
                                  //       className={classes.searchWidgetIcon}
                                  //     />
                                  //   </InputAdornment>
                                  // ),
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                                InputLabelProps={{
                                  sx: {
                                    fontSize: 14,
                                  },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                    {customerName && !selectedId && (
                      <>
                        <Grid item lg={1} md={1}></Grid>
                        <Grid item lg={3} md={3} sm={12} xs={12}>
                          <Grid container alignItems="center">
                            <Grid item>
                              <Grid
                                className={classes.profileBottomDwon23}
                                onClick={() =>
                                  navigate(`/profile/customer/${customer?.id}`)
                                }
                                sx={{
                                  cursor: "pointer",
                                }}
                              >
                                {customer ? (
                                  customer.customerImg ? (
                                    <img
                                      src={customer.customerImg}
                                      alt="Profile"
                                      className={classes.profileImage}
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Travis Howard"
                                      src={AvatarImg}
                                      className={classes.profileImage}
                                    />
                                  )
                                ) : (
                                  <Avatar
                                    alt="Travis Howard"
                                    src={AvatarImg}
                                    className={classes.profileImage}
                                  />
                                )}
                              </Grid>
                            </Grid>
                            <Grid item>
                              <Grid className={classes.profileDetails}>
                                <Typography
                                  variant="h4"
                                  className={classes.profileDetailItem23}
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      // textDecoration: "underline",
                                      // color: "#dae4f0",
                                    }}
                                    onClick={() =>
                                      navigate(
                                        `/profile/customer/${customer?.id}`
                                      )
                                    }
                                  >
                                    {toProperCase(
                                      customer?.customerFirstName || ""
                                    ) +
                                      " " +
                                      toProperCase(
                                        customer?.customerLastName || ""
                                      )}
                                  </span>
                                </Typography>
                                {customer?.customerMobileNum && (
                                  <Typography
                                    variant="body1"
                                    className={classes.contactInfo12}
                                  >
                                    <span className={classes.iconText}>
                                      <PhoneIcon />{" "}
                                      {customer?.customerMobileNum}
                                    </span>
                                  </Typography>
                                )}
                                {customer?.customerEmail && (
                                  <Typography
                                    variant="body1"
                                    className={classes.contactInfo12}
                                  >
                                    <span className={classes.iconText}>
                                      <EmailIcon />{" "}
                                      {customer?.customerEmail?.toLowerCase()}
                                    </span>
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </Card>
              </Grid> */}
              {customerName && selectedId && (
                <>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography className={classes.cardTitle}>
                            Policy Coverage Details
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2} p={1}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {/* <Card className={classes.meetingLable1}> */}
                          <Grid container spacing={1} p={2}>
                            <Grid item lg={4} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center" spacing={1}>
                                <Grid item>
                                  <Grid
                                    className={classes.profileBottomDwon23}
                                    onClick={() =>
                                      navigate(
                                        `/profile/customer/${customer?.id}`
                                      )
                                    }
                                    sx={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {customer ? (
                                      customer.customerImg ? (
                                        <img
                                          src={customer.customerImg}
                                          alt="Profile"
                                          className={classes.profileImage}
                                        />
                                      ) : (
                                        <Avatar
                                          alt="Travis Howard"
                                          src={AvatarImg}
                                          className={classes.profileImage}
                                        />
                                      )
                                    ) : (
                                      <Avatar
                                        alt="Travis Howard"
                                        src={AvatarImg}
                                        className={classes.profileImage}
                                      />
                                    )}
                                  </Grid>
                                </Grid>
                                <Grid item>
                                  <Grid className={classes.profileDetails}>
                                    <Link
                                      to={`/profile/customer/${customer?.id}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Typography
                                        variant="h4"
                                        className={classes.profileDetailItem23}
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          navigate(
                                            `/profile/customer/${customer?.id}`
                                          )
                                        }
                                      >
                                        {toProperCase(
                                          customer?.customerFirstName || ""
                                        ) +
                                          " " +
                                          toProperCase(
                                            customer?.customerLastName || ""
                                          )}
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingLeft: "3px",
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ color: "#1976d2" }}
                                          />
                                        </span>
                                      </Typography>
                                    </Link>
                                    {customer?.customerMobileNum && (
                                      <Typography
                                        variant="body1"
                                        className={classes.contactInfo12}
                                      >
                                        <span className={classes.iconText}>
                                          <PhoneIcon />{" "}
                                          {formatPhoneNumberForDisplaySpace(
                                            customer?.customerMobileNum
                                          )}
                                        </span>
                                      </Typography>
                                    )}
                                    {customer?.customerEmail && (
                                      <Typography
                                        variant="body1"
                                        className={classes.contactInfo12}
                                      >
                                        <span className={classes.iconText}>
                                          <EmailIcon />{" "}
                                          {customer?.customerEmail?.toLowerCase()}
                                        </span>
                                      </Typography>
                                    )}
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid item lg={4} md={12} sm={12} xs={12}>
                              <Grid container alignItems="left">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Policy No
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Link
                                        to={`/customer/${customer?.id}/policy/${formik.values.policyNumber}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography className={classes.text123}>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                            }}
                                          >
                                            {formik.values.policyNumber || " "}
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                paddingLeft: "3px",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faLink}
                                                style={{ color: "#1976d2" }}
                                              />
                                            </span>
                                          </span>
                                        </Typography>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Policy Owner
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Link
                                        to={`/profile/customer/${customer?.id}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography className={classes.text123}>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              // textDecoration: "underline",
                                              // color: "#dae4f0",
                                            }}
                                            // onClick={() =>
                                            //   navigate(
                                            //     `/profile/customer/${customer?.id}`
                                            //   )
                                            // }
                                          >
                                            {toProperCase(
                                              customer?.customerFirstName || ""
                                            ) +
                                              " " +
                                              toProperCase(
                                                customer?.customerLastName || ""
                                              )}
                                            <span
                                              style={{
                                                cursor: "pointer",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                paddingLeft: "3px",
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faUser}
                                                style={{ color: "#1976d2" }}
                                              />
                                            </span>
                                          </span>
                                        </Typography>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Insurance Company
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Typography className={classes.text123}>
                                        {brandMap.get(
                                          Number(
                                            formik.values
                                              .policyInsuranceCompanyId
                                          )
                                        ) || ""}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Jo Po Owner
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Link
                                        to={`/profile/customer/${relatedCustomerIdMap.get(
                                          Number(
                                            formik.values.jointPolicyOwnerId
                                          )
                                        )}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography className={classes.text123}>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              // textDecoration: "underline",
                                              // color: "#dae4f0",
                                            }}
                                            // onClick={() => {
                                            //   const relative = relativeList.find(
                                            //     (c) =>
                                            //       c.id ===
                                            //       Number(
                                            //         formik.values
                                            //           .jointPolicyOwnerId
                                            //       )
                                            //   );
                                            //   if (relative?.related_customer_id) {
                                            //     navigate(
                                            //       `/profile/customer/${relative.related_customer_id}`
                                            //     );
                                            //   }
                                            // }}
                                          >
                                            {relativeMap.get(
                                              Number(
                                                formik.values.jointPolicyOwnerId
                                              )
                                            ) || ""}
                                            {formik.values
                                              .jointPolicyOwnerId && (
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  paddingLeft: "3px",
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faUser}
                                                  style={{ color: "#1976d2" }}
                                                />
                                              </span>
                                            )}
                                          </span>
                                        </Typography>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Co. Po Owner
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Link
                                        to={`/profile/customer/${relatedCustomerIdMap.get(
                                          Number(
                                            formik.values
                                              .contengentPolicyOwnerId
                                          )
                                        )}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Typography className={classes.text123}>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              // textDecoration: "underline",
                                              // color: "#dae4f0",
                                            }}
                                            // onClick={() => {
                                            //   const relative =
                                            //     relativeList.find(
                                            //       (c) =>
                                            //         c.id ===
                                            //         Number(
                                            //           formik.values
                                            //             .contengentPolicyOwnerId
                                            //         )
                                            //     );
                                            //   if (
                                            //     relative?.related_customer_id
                                            //   ) {
                                            //     navigate(
                                            //       `/profile/customer/${relative.related_customer_id}`
                                            //     );
                                            //   }
                                            // }}
                                          >
                                            {relativeMap.get(
                                              Number(
                                                formik.values
                                                  .contengentPolicyOwnerId
                                              )
                                            ) || ""}
                                            {formik.values
                                              .contengentPolicyOwnerId && (
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  display: "inline-flex",
                                                  alignItems: "center",
                                                  paddingLeft: "3px",
                                                }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={faUser}
                                                  style={{ color: "#1976d2" }}
                                                />
                                              </span>
                                            )}
                                          </span>
                                        </Typography>
                                      </Link>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={4} md={12} sm={12} xs={12}>
                              <Grid container alignItems="left">
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Premium
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      {/* {formik.values.policyPremium && ( */}
                                      <Typography className={classes.text123}>
                                        {formik.values.policyPremium
                                          ? `${formatNumber(
                                              formik.values.policyPremium
                                            )}`
                                          : ""}
                                      </Typography>
                                      {/* )} */}
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Issue Date
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Typography className={classes.text123}>
                                        {formik.values.policyIssueDate
                                          ? dayjs(
                                              formik.values.policyIssueDate
                                            ).format("MMM D, YYYY")
                                          : ""}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Premium Frequency
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Typography className={classes.text123}>
                                        {getPolicyCollectionType(
                                          formik.values.policyPremiumFrequency
                                        ) || " "}
                                        {[
                                          "Annually",
                                          "Custom",
                                          "OneTime",
                                        ].includes(
                                          formik.values.policyPremiumFrequency
                                        ) &&
                                          (formik.values
                                            .policyPremiumFrequencyDate
                                            ? ` - ${dayjs(
                                                formik.values
                                                  .policyPremiumFrequencyDate
                                              ).format("MMM D, YYYY")}`
                                            : "")}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Draw Day
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Typography className={classes.text123}>
                                        {formik.values.policyDrawDay || " "}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid
                                    container
                                    className={classes.profileDetails}
                                    spacing={1}
                                  >
                                    <Grid item lg={5} md={4} sm={4} xs={4}>
                                      <Typography className={classes.text12}>
                                        Payor
                                        <span style={{ float: "right" }}>
                                          :
                                        </span>
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={8} sm={8} xs={8}>
                                      <Typography className={classes.text123}>
                                        {toProperCase(
                                          formik.values.policyPayor || " "
                                        )}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* </Card> */}
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid item pt={2} alignContent={"center"}>
                          <Typography className={classes.cardTitle}>
                            Policy Details
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          lg={3}
                          md={6}
                          sm={6}
                          xs={6}
                          pt={2}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid
                            container
                            spacing={1}
                            justifyContent="flex-end"
                            sx={{ display: "flex" }}
                          >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center" spacing={2}>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <Typography
                                    variant="subtitle1"
                                    textAlign={"right"}
                                  >
                                    Order Number
                                  </Typography>
                                </Grid>
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Order Number"
                                    size="small"
                                    {...formik.getFieldProps(
                                      "coverageOrderNumber"
                                    )}
                                    className={classes.textField}
                                    type="number"
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid container spacing={5} p={"24px"}>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container spacing={3}>
                            {selectedId ? (
                              <>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Type of Coverage
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={7}
                                      md={7}
                                      sm={10}
                                      xs={10}
                                      display="flex"
                                      alignItems="center"
                                    >
                                      <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        className={classes.textField}
                                        value={selectedCategoryId || ""}
                                        onChange={handleMainCategoryChange}
                                        InputLabelProps={{ shrink: true }}
                                      >
                                        <MenuItem
                                          value=""
                                          disabled
                                          style={{ color: "gray" }}
                                        >
                                          Select an option
                                        </MenuItem>
                                        {categoryList &&
                                          categoryList.map((category) => (
                                            <MenuItem
                                              key={category.id}
                                              value={category.id}
                                            >
                                              {category.categoryName}
                                            </MenuItem>
                                          ))}
                                      </TextField>
                                    </Grid>
                                    <Grid
                                      item
                                      lg={1}
                                      md={1}
                                      sm={2}
                                      xs={2}
                                      display="flex"
                                      sx={{
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        textAlign: "end",
                                      }}
                                    >
                                      <Button
                                        variant="contained"
                                        className={classes.editButton}
                                        onClick={() => {
                                          setOpenCategory(true);
                                        }}
                                      >
                                        <AddIcon />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>

                                {selectedCategoryId &&
                                  subCategoryList.length > 0 && (
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container alignItems="center">
                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography variant="subtitle1">
                                            Sub Coverage
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={7}
                                          md={7}
                                          sm={12}
                                          xs={12}
                                          display="flex"
                                          alignItems="center"
                                        >
                                          <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            className={classes.textField}
                                            value={
                                              selectedSubCategoryId === null
                                                ? ""
                                                : selectedSubCategoryId
                                            }
                                            onChange={handleSubCategoryChange}
                                            InputLabelProps={{ shrink: true }}
                                          >
                                            <MenuItem
                                              value=""
                                              disabled
                                              style={{ color: "gray" }}
                                            >
                                              Select an option
                                            </MenuItem>
                                            {subCategoryList.map(
                                              (subcategory) => (
                                                <MenuItem
                                                  key={subcategory.id}
                                                  value={subcategory.id}
                                                >
                                                  {subcategory.categoryName}
                                                </MenuItem>
                                              )
                                            )}
                                          </TextField>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}

                                {selectedCategoryId &&
                                  selectedSubCategoryId &&
                                  subToSubCategoryList.length > 0 && (
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container alignItems="center">
                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography variant="subtitle1">
                                            Sub-to-Sub Coverage
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={7}
                                          md={7}
                                          sm={12}
                                          xs={12}
                                          display="flex"
                                          alignItems="center"
                                        >
                                          <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            className={classes.textField}
                                            value={
                                              selectedSubToSubCategoryId ===
                                              null
                                                ? ""
                                                : selectedSubToSubCategoryId
                                            }
                                            onChange={
                                              handleSubToSubCategoryChange
                                            }
                                            InputLabelProps={{ shrink: true }}
                                          >
                                            <MenuItem
                                              value=""
                                              disabled
                                              style={{ color: "gray" }}
                                            >
                                              Select an option
                                            </MenuItem>
                                            {subToSubCategoryList.map(
                                              (subToSubcategory) => (
                                                <MenuItem
                                                  key={subToSubcategory.id}
                                                  value={subToSubcategory.id}
                                                >
                                                  {
                                                    subToSubcategory.categoryName
                                                  }
                                                </MenuItem>
                                              )
                                            )}
                                          </TextField>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}

                                {selectedCategoryId &&
                                  selectedSubCategoryId &&
                                  selectedSubToSubCategoryId &&
                                  subToSubToSubCategoryList.length > 0 && (
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container alignItems="center">
                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography variant="subtitle1">
                                            Sub-to-Sub-to-Sub Coverage
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={7}
                                          md={7}
                                          sm={12}
                                          xs={12}
                                          display="flex"
                                          alignItems="center"
                                        >
                                          <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            className={classes.textField}
                                            value={
                                              selectedSubToSubToSubCategoryId ===
                                              null
                                                ? ""
                                                : selectedSubToSubToSubCategoryId
                                            }
                                            onChange={
                                              handleSubToSubToSubCategoryChange
                                            }
                                            InputLabelProps={{ shrink: true }}
                                          >
                                            <MenuItem
                                              value=""
                                              disabled
                                              style={{ color: "gray" }}
                                            >
                                              Select an option
                                            </MenuItem>
                                            {subToSubToSubCategoryList.map(
                                              (subToSubToSubcategory) => (
                                                <MenuItem
                                                  key={subToSubToSubcategory.id}
                                                  value={
                                                    subToSubToSubcategory.id
                                                  }
                                                >
                                                  {
                                                    subToSubToSubcategory.categoryName
                                                  }
                                                </MenuItem>
                                              )
                                            )}
                                          </TextField>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  )}
                              </>
                            ) : (
                              <>
                                <Grid item lg={12} md={12} sm={12} xs={12}>
                                  <Grid container alignItems="center">
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                      <Typography variant="subtitle1">
                                        Type of Coverage
                                      </Typography>
                                    </Grid>
                                    <Grid item lg={7} md={7} sm={10} xs={10}>
                                      <TextField
                                        placeholder="Enter Product Category Name"
                                        size="small"
                                        className={classes.textField}
                                        InputProps={{
                                          sx: {
                                            fontSize: 14,
                                          },
                                        }}
                                        InputLabelProps={{
                                          sx: {
                                            fontSize: 14,
                                          },
                                        }}
                                        value={
                                          coursingMap.get(
                                            formik.values.policyCategoryId
                                          ) || ""
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      lg={1}
                                      md={1}
                                      sm={2}
                                      xs={2}
                                      display="flex"
                                      sx={{
                                        justifyContent: "flex-end",
                                        alignItems: "flex-end",
                                        textAlign: "end",
                                      }}
                                    >
                                      <Button
                                        variant="contained"
                                        className={classes.editButton}
                                        onClick={handleShowCategorySelection}
                                      >
                                        <ChangeCircleIcon />
                                      </Button>
                                    </Grid>
                                  </Grid>
                                </Grid>
                                {showCategorySelection && (
                                  <>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                      <Grid container alignItems="center">
                                        <Grid
                                          item
                                          lg={4}
                                          md={4}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Typography variant="subtitle1">
                                            Type of Coverage
                                          </Typography>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={7}
                                          md={7}
                                          sm={10}
                                          xs={10}
                                          display="flex"
                                          alignItems="center"
                                        >
                                          <TextField
                                            select
                                            fullWidth
                                            size="small"
                                            className={classes.textField}
                                            value={selectedCategoryId || ""}
                                            onChange={handleMainCategoryChange}
                                            InputLabelProps={{ shrink: true }}
                                          >
                                            <MenuItem
                                              value=""
                                              disabled
                                              style={{ color: "gray" }}
                                            >
                                              Select an option
                                            </MenuItem>
                                            {categoryList &&
                                              categoryList.map((category) => (
                                                <MenuItem
                                                  key={category.id}
                                                  value={category.id}
                                                >
                                                  {category.categoryName}
                                                </MenuItem>
                                              ))}
                                          </TextField>
                                        </Grid>
                                        <Grid
                                          item
                                          lg={1}
                                          md={1}
                                          sm={2}
                                          xs={2}
                                          display="flex"
                                          sx={{
                                            justifyContent: "flex-end",
                                            alignItems: "flex-end",
                                            textAlign: "end",
                                          }}
                                        >
                                          <Button
                                            variant="contained"
                                            className={classes.editButton}
                                            onClick={() => {
                                              setOpenCategory(true);
                                            }}
                                          >
                                            <AddIcon />
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </Grid>

                                    {selectedCategoryId &&
                                      subCategoryList.length > 0 && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid container alignItems="center">
                                            <Grid
                                              item
                                              lg={4}
                                              md={4}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography variant="subtitle1">
                                                Sub Coverage
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={8}
                                              md={8}
                                              sm={12}
                                              xs={12}
                                              display="flex"
                                              alignItems="center"
                                            >
                                              <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                className={classes.textField}
                                                value={
                                                  selectedSubCategoryId === null
                                                    ? ""
                                                    : selectedSubCategoryId
                                                }
                                                onChange={
                                                  handleSubCategoryChange
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                              >
                                                <MenuItem
                                                  value=""
                                                  disabled
                                                  style={{ color: "gray" }}
                                                >
                                                  Select an option
                                                </MenuItem>
                                                {subCategoryList.map(
                                                  (subcategory) => (
                                                    <MenuItem
                                                      key={subcategory.id}
                                                      value={subcategory.id}
                                                    >
                                                      {subcategory.categoryName}
                                                    </MenuItem>
                                                  )
                                                )}
                                              </TextField>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}

                                    {selectedCategoryId &&
                                      selectedSubCategoryId &&
                                      subToSubCategoryList.length > 0 && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid container alignItems="center">
                                            <Grid
                                              item
                                              lg={4}
                                              md={4}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography variant="subtitle1">
                                                Sub-to-Sub Coverage
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={8}
                                              md={8}
                                              sm={12}
                                              xs={12}
                                              display="flex"
                                              alignItems="center"
                                            >
                                              <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                className={classes.textField}
                                                value={
                                                  selectedSubToSubCategoryId ===
                                                  null
                                                    ? ""
                                                    : selectedSubToSubCategoryId
                                                }
                                                onChange={
                                                  handleSubToSubCategoryChange
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                              >
                                                <MenuItem
                                                  value=""
                                                  disabled
                                                  style={{ color: "gray" }}
                                                >
                                                  Select an option
                                                </MenuItem>
                                                {subToSubCategoryList.map(
                                                  (subToSubcategory) => (
                                                    <MenuItem
                                                      key={subToSubcategory.id}
                                                      value={
                                                        subToSubcategory.id
                                                      }
                                                    >
                                                      {
                                                        subToSubcategory.categoryName
                                                      }
                                                    </MenuItem>
                                                  )
                                                )}
                                              </TextField>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}

                                    {selectedCategoryId &&
                                      selectedSubCategoryId &&
                                      selectedSubToSubCategoryId &&
                                      subToSubToSubCategoryList.length > 0 && (
                                        <Grid
                                          item
                                          lg={12}
                                          md={12}
                                          sm={12}
                                          xs={12}
                                        >
                                          <Grid container alignItems="center">
                                            <Grid
                                              item
                                              lg={4}
                                              md={4}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography variant="subtitle1">
                                                Sub-to-Sub-to-Sub Coverage
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={8}
                                              md={8}
                                              sm={12}
                                              xs={12}
                                              display="flex"
                                              alignItems="center"
                                            >
                                              <TextField
                                                select
                                                fullWidth
                                                size="small"
                                                className={classes.textField}
                                                value={
                                                  selectedSubToSubToSubCategoryId ===
                                                  null
                                                    ? ""
                                                    : selectedSubToSubToSubCategoryId
                                                }
                                                onChange={
                                                  handleSubToSubToSubCategoryChange
                                                }
                                                InputLabelProps={{
                                                  shrink: true,
                                                }}
                                              >
                                                <MenuItem
                                                  value=""
                                                  disabled
                                                  style={{ color: "gray" }}
                                                >
                                                  Select an option
                                                </MenuItem>
                                                {subToSubToSubCategoryList.map(
                                                  (subToSubToSubcategory) => (
                                                    <MenuItem
                                                      key={
                                                        subToSubToSubcategory.id
                                                      }
                                                      value={
                                                        subToSubToSubcategory.id
                                                      }
                                                    >
                                                      {
                                                        subToSubToSubcategory.categoryName
                                                      }
                                                    </MenuItem>
                                                  )
                                                )}
                                              </TextField>
                                            </Grid>
                                          </Grid>
                                        </Grid>
                                      )}
                                  </>
                                )}
                              </>
                            )}
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Product Description
                                  </Typography>
                                </Grid>
                                <Grid item lg={7} md={7} sm={10} xs={10}>
                                  <TextField
                                    select
                                    size="small"
                                    className={classes.textField}
                                    defaultValue=""
                                    InputLabelProps={{ shrink: true }}
                                    {...formik.getFieldProps("policyProductId")}
                                  >
                                    <MenuItem
                                      value=""
                                      style={{ color: "gray" }}
                                    >
                                      Select an option
                                    </MenuItem>
                                    {productList &&
                                      productList.map((product) => (
                                        <MenuItem
                                          key={product.id}
                                          value={product.id}
                                        >
                                          {product.productName}
                                        </MenuItem>
                                      ))}
                                  </TextField>
                                </Grid>
                                <Grid
                                  item
                                  lg={1}
                                  md={1}
                                  sm={2}
                                  xs={2}
                                  display="flex"
                                  sx={{
                                    justifyContent: "flex-end",
                                    alignItems: "flex-end",
                                    textAlign: "end",
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    className={classes.editButton}
                                    onClick={() => {
                                      setOpenProduct(true);
                                    }}
                                  >
                                    <AddIcon />
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container spacing={3}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Expiry Date
                                  </Typography>
                                </Grid>
                                <Grid item lg={3} md={3} sm={12} xs={12}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          formik.values
                                            .policyIsLifeTimeExpiryDate
                                        }
                                        onChange={(e) => {
                                          const isChecked = e.target.checked;
                                          formik.setFieldValue(
                                            "policyIsLifeTimeExpiryDate",
                                            isChecked
                                          );

                                          // If lifetime policy is selected, set policyExpiryDate to null
                                          formik.setFieldValue(
                                            "policyExpiryDate",
                                            isChecked
                                              ? null
                                              : formik.values.policyExpiryDate
                                          );
                                        }}
                                      />
                                    }
                                    label="Death"
                                  />
                                </Grid>
                                {formik.values.policyIsLifeTimeExpiryDate ===
                                  false && (
                                  <Grid item lg={5} md={5} sm={12} xs={12}>
                                    <LocalizationProvider
                                      dateAdapter={AdapterDayjs}
                                    >
                                      <DatePicker
                                        value={formik.values.policyExpiryDate}
                                        onChange={(date) =>
                                          formik.setFieldValue(
                                            "policyExpiryDate",
                                            date
                                          )
                                        }
                                        slotProps={{
                                          textField: {
                                            size: "small",
                                            sx: { width: "100%" },
                                            InputProps: {
                                              sx: { fontSize: 14 },
                                            },
                                            InputLabelProps: {
                                              sx: { fontSize: 14 },
                                            },
                                          },
                                        }}
                                      />
                                    </LocalizationProvider>
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Coversion Date
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={formik.values.policyCoversionDate}
                                      onChange={(date) =>
                                        formik.setFieldValue(
                                          "policyCoversionDate",
                                          date
                                        )
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          sx: { width: "100%" },
                                          InputProps: {
                                            sx: { fontSize: 14 },
                                          },
                                          InputLabelProps: {
                                            sx: { fontSize: 14 },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Renewal Date
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={formik.values.policyRenewalDate}
                                      onChange={(date) =>
                                        formik.setFieldValue(
                                          "policyRenewalDate",
                                          date
                                        )
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          sx: { width: "100%" },
                                          InputProps: {
                                            sx: { fontSize: 14 },
                                          },
                                          InputLabelProps: {
                                            sx: { fontSize: 14 },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Paid Up Date
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <LocalizationProvider
                                    dateAdapter={AdapterDayjs}
                                  >
                                    <DatePicker
                                      value={formik.values.policyPaidUpDate}
                                      onChange={(date) =>
                                        formik.setFieldValue(
                                          "policyPaidUpDate",
                                          date
                                        )
                                      }
                                      slotProps={{
                                        textField: {
                                          size: "small",
                                          sx: { width: "100%" },
                                          InputProps: {
                                            sx: { fontSize: 14 },
                                          },
                                          InputLabelProps: {
                                            sx: { fontSize: 14 },
                                          },
                                        },
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Card className={classes.card}>
                      <Grid
                        container
                        justifyContent={"space-between"}
                        spacing={5}
                        sx={{ borderBottom: 2, padding: 2 }}
                        className={classes.titleGrid}
                      >
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          pt={2}
                          alignContent={"center"}
                        >
                          <Typography className={classes.cardTitle}>
                            Premium Details
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container spacing={5} p={"24px"}>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container spacing={3}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Premium Details
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Enter Premium Details"
                                    size="small"
                                    {...formik.getFieldProps(
                                      "policyPremiumDetails"
                                    )}
                                    type="number"
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Premium
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Enter Premium"
                                    size="small"
                                    {...formik.getFieldProps("policyPremium")}
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid> */}
                          </Grid>
                        </Grid>
                        <Grid item lg={6} md={12} sm={12} xs={12}>
                          <Grid container spacing={3}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Coverage Amount
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <TextField
                                    placeholder="Enter Coverage Amount"
                                    size="small"
                                    type="number"
                                    {...formik.getFieldProps(
                                      "policyCoverageAmount"
                                    )}
                                    className={classes.textField}
                                    InputProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: 14,
                                      },
                                    }}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>

                            {/* <Grid item lg={12} md={12} sm={12} xs={12}>
                              <Grid container alignItems="center">
                                <Grid item lg={4} md={4} sm={12} xs={12}>
                                  <Typography variant="subtitle1">
                                    Premium Frequency
                                  </Typography>
                                </Grid>
                                <Grid item lg={8} md={8} sm={12} xs={12}>
                                  <TextField
                                    select
                                    size="small"
                                    className={classes.textField}
                                    SelectProps={{
                                      native: false,
                                    }}
                                    defaultValue=""
                                    InputLabelProps={{ shrink: true }}
                                    {...formik.getFieldProps(
                                      "policyPremiumFrequency"
                                    )}
                                  >
                                    <MenuItem value="" disabled>
                                      Select an option
                                    </MenuItem>

                                    {Object.entries(PolicyCollectionType).map(
                                      ([key, value], index) => (
                                        <MenuItem key={index} value={value}>
                                          {getPolicyCollectionType(value)}
                                        </MenuItem>
                                      )
                                    )}
                                  </TextField>
                                </Grid>
                              </Grid>
                            </Grid> */}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  </Grid>
                </>
              )}
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Insured Details
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  Insured
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Relat
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {relativeIsLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : relativeError ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    Error fetching data
                                  </TableCell>
                                </TableRow>
                              ) : (
                                relativeList &&
                                selectedCustomerIds.map((id, index) => {
                                  const relative = relativeList.find(
                                    (c) => c.id === id
                                  );

                                  return (
                                    <TableRow key={index}>
                                      <TableCell className={classes.tablCell}>
                                        {cutomerMap.get(
                                          relative?.related_customer_id ?? ""
                                        )}
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        {relative?.relationship_type ?? ""}
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Grid item>
                                            <IconButton
                                              color="error"
                                              onClick={() =>
                                                handleOpenDeleteProjectPopup(
                                                  id,
                                                  "insured",
                                                  cutomerMap.get(
                                                    relative?.related_customer_id ??
                                                      ""
                                                  )
                                                )
                                              }
                                            >
                                              <FaTrash />
                                            </IconButton>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          py={2}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={handleOpenDialog}
                          >
                            Add Insured
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={5}></Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Primary Benificaries
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  Name
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Relat
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Payout percentage
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Type
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {relativeIsLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : relativeError || policyPB.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {relativeError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                relativeList &&
                                policyPB.map((row, index) => {
                                  const relative = relativeList.find(
                                    (c) => c.id === row.column1
                                  );

                                  return (
                                    <TableRow key={index}>
                                      <TableCell className={classes.tablCell}>
                                        {cutomerMap.get(
                                          relative?.related_customer_id ?? ""
                                        )}
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        {/* {relative?.relationship_type ?? ""} */}
                                        <Autocomplete
                                          options={Object.values(
                                            RelationshipType
                                          )}
                                          value={row.relationship || ""}
                                          onChange={(event, newValue) =>
                                            handleFieldChangePB(
                                              index,
                                              "relationship",
                                              newValue || ""
                                            )
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Relationship.."
                                              size="small"
                                              className={classes.textField}
                                              InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                  minWidth: "150px",
                                                },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                  notchedOutline:
                                                    classes.notchedOutline,
                                                },
                                              }}
                                              InputLabelProps={{
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                },
                                              }}
                                            />
                                          )}
                                          sx={{ width: "200px" }}
                                          size="small"
                                          className={classes.searchTextField23}
                                        />
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        <TextField
                                          placeholder="Payout percentage"
                                          size="small"
                                          value={row.payoutPercentage}
                                          onChange={(e) =>
                                            handleFieldChangePB(
                                              index,
                                              "payoutPercentage",
                                              String(e.target.value)
                                            )
                                          }
                                          type="number"
                                          className={classes.textField}
                                          InputProps={{
                                            sx: {
                                              fontSize: 14,
                                              border: "none",
                                            },
                                            classes: {
                                              root: classes.textFieldQuote,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          }}
                                          InputLabelProps={{
                                            sx: {
                                              fontSize: 14,
                                              border: "none",
                                            },
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell className={classes.tablCell}>
                                        <Autocomplete
                                          options={Object.values(
                                            BenificeryType
                                          )}
                                          value={row.column2 || ""}
                                          onChange={(event, newValue) =>
                                            handleFieldChangePB(
                                              index,
                                              "column2",
                                              newValue || ""
                                            )
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Benefit type.."
                                              size="small"
                                              className={classes.textField}
                                              InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                  minWidth: "150px",
                                                },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                  notchedOutline:
                                                    classes.notchedOutline,
                                                },
                                              }}
                                              InputLabelProps={{
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                },
                                              }}
                                            />
                                          )}
                                          sx={{ width: "200px" }}
                                          size="small"
                                          className={classes.searchTextField23}
                                        />
                                      </TableCell>
                                      <TableCell className={classes.tablCell}>
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Grid item>
                                            <IconButton
                                              color="error"
                                              // onClick={() =>
                                              //   handleDeleteRowPB(index)
                                              // }

                                              onClick={() =>
                                                handleOpenDeleteProjectPopup(
                                                  index,
                                                  "pb",
                                                  cutomerMap.get(
                                                    relative?.related_customer_id ??
                                                      ""
                                                  )
                                                )
                                              }
                                            >
                                              <FaTrash />
                                            </IconButton>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          py={2}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={handleOpenDialogPB}
                          >
                            Add Pri Benifi
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={5}></Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Contengent Benificaries
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <Grid
                        container
                        direction="row"
                        alignItems="center"
                        spacing={2}
                      >
                        <TableContainer>
                          <Table className={classes.table}>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  Name
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Relat
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  Payout percentage
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  Action
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {relativeIsLoading ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    <Box
                                      display="flex"
                                      justifyContent="center"
                                      alignItems="center"
                                      height="10vh"
                                    >
                                      <CircularProgress />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                              ) : relativeError || policyCB.length === 0 ? (
                                <TableRow>
                                  <TableCell colSpan={20} align="center">
                                    {relativeError
                                      ? "Error fetching data"
                                      : "No data available"}
                                  </TableCell>
                                </TableRow>
                              ) : (
                                relativeList &&
                                policyCB.map((row, index) => {
                                  const relative = relativeList.find(
                                    (c) => c.id === row.column1
                                  );

                                  return (
                                    <TableRow key={index}>
                                      <TableCell className={classes.tablCell}>
                                        {cutomerMap.get(
                                          relative?.related_customer_id ?? ""
                                        )}
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        {/* {relative?.relationship_type ?? ""} */}
                                        <Autocomplete
                                          options={Object.values(
                                            RelationshipType
                                          )}
                                          value={row.relationship || ""}
                                          onChange={(event, newValue) =>
                                            handleFieldChangeCB(
                                              index,
                                              "relationship",
                                              newValue || ""
                                            )
                                          }
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Relationship.."
                                              size="small"
                                              className={classes.textField}
                                              InputProps={{
                                                ...params.InputProps,
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                  minWidth: "150px",
                                                },
                                                classes: {
                                                  root: classes.textFieldQuote,
                                                  notchedOutline:
                                                    classes.notchedOutline,
                                                },
                                              }}
                                              InputLabelProps={{
                                                sx: {
                                                  fontSize: 14,
                                                  border: "none",
                                                },
                                              }}
                                            />
                                          )}
                                          sx={{ width: "200px" }}
                                          size="small"
                                          className={classes.searchTextField23}
                                        />
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        <TextField
                                          placeholder="Payout percentage"
                                          size="small"
                                          value={row.payoutPercentage}
                                          onChange={(e) =>
                                            handleFieldChangeCB(
                                              index,
                                              "payoutPercentage",
                                              String(e.target.value)
                                            )
                                          }
                                          type="number"
                                          className={classes.textField}
                                          InputProps={{
                                            sx: {
                                              fontSize: 14,
                                              border: "none",
                                            },
                                            classes: {
                                              root: classes.textFieldQuote,
                                              notchedOutline:
                                                classes.notchedOutline,
                                            },
                                          }}
                                          InputLabelProps={{
                                            sx: {
                                              fontSize: 14,
                                              border: "none",
                                            },
                                          }}
                                        />
                                      </TableCell>

                                      <TableCell className={classes.tablCell}>
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Grid item>
                                            <IconButton
                                              color="error"
                                              // onClick={() =>
                                              //   handleDeleteRowCB(index)
                                              // }

                                              onClick={() =>
                                                handleOpenDeleteProjectPopup(
                                                  index,
                                                  "cb",
                                                  cutomerMap.get(
                                                    relative?.related_customer_id ??
                                                      ""
                                                  )
                                                )
                                              }
                                            >
                                              <FaTrash />
                                            </IconButton>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  );
                                })
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <Grid
                          item
                          lg={12}
                          md={12}
                          sm={12}
                          xs={12}
                          py={2}
                          sx={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                        >
                          <Button
                            variant="contained"
                            className={classes.addButton}
                            onClick={handleOpenDialogCB}
                          >
                            Add Cont Benifi
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid container spacing={5}></Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    spacing={5}
                    sx={{ borderBottom: 2, padding: 2 }}
                    className={classes.titleGrid}
                  >
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      pt={2}
                      alignContent={"center"}
                    >
                      <Typography className={classes.cardTitle}>
                        Summary Report
                      </Typography>
                    </Grid>
                  </Grid>
                  {currentTerm.map((product, index) => (
                    <Grid container spacing={2} p={"24px"} key={index}>
                      <Grid item lg={9} md={8} sm={8} xs={12}>
                        <ReactQuill
                          value={product.policyTermsDescription}
                          onChange={(newValue) =>
                            handleFieldChange(
                              index,
                              "policyTermsDescription",
                              newValue
                            )
                          }
                          placeholder="Enter Terms..."
                          theme="snow"
                          style={{
                            height: widthofReactQuill["200px"],
                            marginBottom: "20px",
                          }}
                          modules={{
                            toolbar: [
                              [{ font: [] }],
                              [{ header: [1, 2, 3, 4, 5, 6, false] }],
                              ["bold", "italic", "underline", "strike"],
                              [{ color: [] }, { background: [] }],
                              [{ script: "sub" }, { script: "super" }],
                              [{ list: "ordered" }, { list: "bullet" }],
                              [{ indent: "-1" }, { indent: "+1" }],
                              [{ direction: "rtl" }],
                              [{ align: [] }],
                              ["blockquote", "code-block"],
                              ["link", "image", "video"],
                              ["clean"],
                            ],
                          }}
                        />
                        {/* <TextField
                          placeholder="Enter Terms"
                          size="small"
                          value={product.policyTermsDescription}
                          onChange={(e) =>
                            handleFieldChange(
                              index,
                              "policyTermsDescription",
                              String(e.target.value)
                            )
                          }
                          multiline
                          rows={8}
                          className={classes.textField}
                          InputProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              fontSize: 14,
                            },
                          }}
                        /> */}
                      </Grid>
                      <Grid item lg={3} md={4} sm={4} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container>
                              <Grid item lg={3} md={3} sm={6} xs={6}>
                                <IOSSwitch
                                  color="primary"
                                  sx={{ mr: 2 }}
                                  checked={Boolean(
                                    product.isPolicyTermsSummaryReport
                                  )}
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "isPolicyTermsSummaryReport",
                                      Boolean(e.target.checked)
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item lg={9} md={9} sm={6} xs={6}>
                                <Typography variant="subtitle1">
                                  Summary Report
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container>
                              <Grid item lg={3} md={3} sm={6} xs={6}>
                                <IOSSwitch
                                  color="primary"
                                  sx={{ mr: 2 }}
                                  checked={Boolean(product.isPolicyTermsAll)}
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "isPolicyTermsAll",
                                      Boolean(e.target.checked)
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item lg={9} md={9} sm={6} xs={6}>
                                <Typography variant="subtitle1">All</Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Grid container>
                              <Grid item lg={3} md={3} sm={6} xs={6}>
                                <IOSSwitch
                                  color="primary"
                                  sx={{ mr: 2 }}
                                  checked={Boolean(
                                    product.isPolicyTermsPrintPdf
                                  )}
                                  onChange={(e) =>
                                    handleFieldChange(
                                      index,
                                      "isPolicyTermsPrintPdf",
                                      Boolean(e.target.checked)
                                    )
                                  }
                                />
                              </Grid>
                              <Grid item lg={9} md={9} sm={6} xs={6}>
                                <Typography variant="subtitle1">
                                  Print-PDF
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            sx={{
                              display: "flex",
                              justifyContent: "flex-end",
                            }}
                          >
                            <IconButton
                              color="error"
                              // onClick={() => handleDeleteRow(index)}
                              onClick={() =>
                                handleOpenDeleteProjectPopup(index, "terms", "")
                              }
                            >
                              <FaTrash />
                            </IconButton>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}
                  <Grid container spacing={2} p={"24px"}>
                    <Grid
                      item
                      lg={10}
                      md={10}
                      sm={12}
                      xs={12}
                      p={2}
                      // sx={{
                      //   display: "flex",
                      //   justifyContent: "flex-end",
                      // }}
                    >
                      {/* <Button
                        variant="contained"
                        className={classes.editButton}
                        onClick={handleAddRow}
                      >
                        <AddIcon />
                      </Button> */}
                      <Button
                        variant="contained"
                        className={classes.addButton}
                        onClick={handleAddRow}
                      >
                        Add New
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid container spacing={2} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.cardTitle}>
                        Remark
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <ReactQuill
                        value={formik.values.policyRemark}
                        onChange={(value) =>
                          formik.setFieldValue("policyRemark", value)
                        }
                        placeholder="Enter Remark..."
                        theme="snow"
                        style={{
                          height: widthofReactQuill["300px"],
                          marginBottom: "20px",
                        }}
                        modules={{
                          toolbar: [
                            [{ font: [] }],
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            ["bold", "italic", "underline", "strike"],
                            [{ color: [] }, { background: [] }],
                            [{ script: "sub" }, { script: "super" }],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            [{ direction: "rtl" }],
                            [{ align: [] }],
                            ["blockquote", "code-block"],
                            ["link", "image", "video"],
                            ["clean"],
                          ],
                        }}
                      />
                      {/* <TextField
                        placeholder="Enter Remark"
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps("policyRemark")}
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      /> */}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Card className={classes.card}>
                  <Grid container spacing={2} p={"24px"}>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Typography className={classes.cardTitle}>
                        Office Use
                      </Typography>
                    </Grid>
                    <Grid item lg={12} md={12} sm={12} xs={12} pb={5}>
                      <ReactQuill
                        value={formik.values.policyOfficeUse}
                        onChange={(value) =>
                          formik.setFieldValue("policyOfficeUse", value)
                        }
                        placeholder="Enter Office Use Remark..."
                        theme="snow"
                        style={{
                          height: widthofReactQuill["300px"],
                          marginBottom: "20px",
                        }}
                        modules={{
                          toolbar: [
                            [{ font: [] }],
                            [{ header: [1, 2, 3, 4, 5, 6, false] }],
                            ["bold", "italic", "underline", "strike"],
                            [{ color: [] }, { background: [] }],
                            [{ script: "sub" }, { script: "super" }],
                            [{ list: "ordered" }, { list: "bullet" }],
                            [{ indent: "-1" }, { indent: "+1" }],
                            [{ direction: "rtl" }],
                            [{ align: [] }],
                            ["blockquote", "code-block"],
                            ["link", "image", "video"],
                            ["clean"],
                          ],
                        }}
                      />
                      {/* <TextField
                        placeholder="Enter Office Use Remark"
                        size="small"
                        multiline
                        rows={8}
                        {...formik.getFieldProps("policyOfficeUse")}
                        className={classes.textField}
                        InputProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                        InputLabelProps={{
                          sx: {
                            fontSize: 14,
                          },
                        }}
                      /> */}
                    </Grid>
                  </Grid>
                </Card>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                <Card className={classes.card}>
                  <Grid container spacing={3} p={"24px"}>
                    <Grid
                      item
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                      sx={{ display: "flex", justifyContent: "flex-end" }}
                    >
                      <Button
                        variant="outlined"
                        startIcon={<CloseIcon />}
                        className={classes.addButton}
                        onClick={() => handelColseFunction()}
                      >
                        Cancel
                      </Button>
                      <Box m={0.5}></Box>

                      <Button
                        variant="contained"
                        startIcon={<BiSolidMessageSquareAdd />}
                        className={classes.addButton}
                        onClick={() => formik.handleSubmit()}
                        // disabled={!formValid || isLoading}
                      >
                        Create
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              {openDialogPB && (
                <NewPopUpRelativeComponent
                  openModel={openDialogPB}
                  handleCloseDialog={handleCloseDialogPB}
                  policyPBgetAll={policyPB}
                  customerClientId={String(customerId)}
                  handlegetArray={setpolicyPB}
                  heading="Select Primary Benificaries Relative"
                />
              )}

              {openDialogCB && (
                <NewPopUpRelativeComponent
                  openModel={openDialogCB}
                  handleCloseDialog={handleCloseDialogCB}
                  policyPBgetAll={policyCB}
                  customerClientId={String(customerId)}
                  handlegetArray={setpolicyCB}
                  heading="Select Contengent Benificaries Relative"
                />
              )}

              {/* {openDialog && (
                <NewPopUpRelativeComponent
                  openModel={openDialog}
                  handleCloseDialog={handleCloseDialog}
                  policyPBgetAll={policyCB}
                  customerClientId={String(customerId)}
                  handlegetArray={setpolicyCB}
                  heading="Select Contengent Benificaries Relative"
                />
              )} */}

              {openDialog && (
                <NewPopUpRelativeInsuredComponent
                  openModel={openDialog}
                  handleCloseDialog={handleCloseDialog}
                  selectedCustomerIdsGetAll={selectedCustomerIds}
                  customerClientId={String(customerId)}
                  handlegetArray={setSelectedCustomerIds}
                  heading="Select Insured"
                />
              )}
              {openDeleteProject && (
                <DeletePopup
                  open={openDeleteProject}
                  handleCloseDelete={handleCloseDeleteProjectPopup}
                  onConfirm={async () => {
                    await handleOpenDeleteConfirm();
                  }}
                  title={deleteconformationTitile}
                  content={deleteconformationMessage}
                />
              )}
              {/* <Dialog
                open={openDialogPB}
                onClose={handleCloseDialogPB}
                aria-describedby="alert-dialog-description"
                classes={{ paper: "inherit" }}
                fullScreen={isMobile}
                fullWidth={isMobile}
                maxWidth="lg"
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography className={classes.cardTitle}>
                      Select Primary Benificaries Relative
                    </Typography>

                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleCloseDialogPB}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>

                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                     <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile & Name .."
                      sx={{ width: "100%", maxWidth: "400px" }}
                      size="small"
                    />

                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={() => {
                        setSelectedCoursing(undefined);
                        setOpenDialogAddProduct(true);
                      }}
                    >
                      Add Client
                    </Button> 
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleOpenDialogRelative}
                    >
                      Add Relative
                    </Button>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    {relativeIsLoading ? (
                      <CircularProgress />
                    ) : (
                      <TableContainer>
                        <Table>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Client Name{" "}
                                </strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Relationship{" "}
                                </strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "end" }}
                              >
                                <strong className={classes.cardTitle}>
                                  Action{" "}
                                </strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.isArray(relativeData?.data) ? (
                              relativeData?.data.map(
                                (customer: ICustomerRelative) => (
                                  <TableRow key={customer.id}>
                                    <TableCell>
                                      {cutomerMap.get(
                                        customer.related_customer_id
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {customer.relationship_type}
                                    </TableCell>
                                    <TableCell>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            onClick={() =>
                                              handleSelectCustomerPrimaryBenifi(customer)
                                            }
                                            disabled={
                                              typeof customer.id === "number" &&
                                              policyPB.some((row) => row.column1 === customer.id)
                                            }
                                          >
                                            Select
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  No clients found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleCloseDialogPB}
                    >
                      Close
                    </Button>
                    <Box m={0.5}></Box>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleCloseDialogPB}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
                {openAddProject && (
                  <NewPopUpRelative
                    openModel={openAddProject}
                    handleCloseDialog={handleCloseDialogRelative}
                    // data={coursings}
                    customerClientId={String(customerId)}
                  />
                )}
              </Dialog> */}

              {/* <Dialog
                open={openDialogCB}
                onClose={handleCloseDialogCB}
                aria-describedby="alert-dialog-description"
                classes={{ paper: "inherit" }}
                fullScreen={isMobile}
                fullWidth={isMobile}
                maxWidth="lg"
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography className={classes.cardTitle}>
                      Select Contengent Benificaries Relative
                    </Typography>

                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleCloseDialogPB}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>

                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                     <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile & Name .."
                      sx={{ width: "100%", maxWidth: "400px" }}
                      size="small"
                    />

                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={() => {
                        setSelectedCoursing(undefined);
                        setOpenDialogAddProduct(true);
                      }}
                    >
                      Add Client
                    </Button> 
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleOpenDialogRelative}
                    >
                      Add Relative
                    </Button>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    {relativeIsLoading ? (
                      <CircularProgress />
                    ) : (
                      <TableContainer>
                        <Table>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Client Name{" "}
                                </strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Relationship{" "}
                                </strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "end" }}
                              >
                                <strong className={classes.cardTitle}>
                                  Action{" "}
                                </strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.isArray(relativeData?.data) ? (
                              relativeData?.data.map(
                                (customer: ICustomerRelative) => (
                                  <TableRow key={customer.id}>
                                    <TableCell>
                                      {cutomerMap.get(
                                        customer.related_customer_id
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {customer.relationship_type}
                                    </TableCell>
                                    <TableCell>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            onClick={() =>
                                              handleSelectCustomerConBenifi(customer)
                                            }
                                            disabled={
                                              typeof customer.id === "number" &&
                                              policyCB.some((row) => row.column1 === customer.id)
                                            }
                                          >
                                            Select
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  No clients found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleCloseDialogCB}
                    >
                      Close
                    </Button>
                    <Box m={0.5}></Box>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleCloseDialogCB}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
                {openAddProject && (
                  <NewPopUpRelative
                    openModel={openAddProject}
                    handleCloseDialog={handleCloseDialogRelative}
                    // data={coursings}
                    customerClientId={String(customerId)}
                  />
                )}
              </Dialog> */}

              {/* <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-describedby="alert-dialog-description"
                classes={{ paper: "inherit" }}
                fullScreen={isMobile}
                fullWidth={isMobile}
                maxWidth="lg"
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography className={classes.cardTitle}>
                      Select Relative
                    </Typography>

                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleCloseDialog}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>

                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                   <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile & Name .."
                      sx={{ width: "100%", maxWidth: "400px" }}
                      size="small"
                    />

                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={() => {
                        setSelectedCoursing(undefined);
                        setOpenDialogAddProduct(true);
                      }}
                    >
                      Add Client
                    </Button>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleOpenDialogRelative}
                    >
                      Add Relative
                    </Button>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    {relativeIsLoading ? (
                      <CircularProgress />
                    ) : (
                      <TableContainer>
                        <Table>
                          <TableHead className={classes.tableHeaderRow}>
                            <TableRow>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Client Name{" "}
                                </strong>
                              </TableCell>
                              <TableCell className={classes.tablheader}>
                                <strong className={classes.cardTitle}>
                                  Relationship{" "}
                                </strong>
                              </TableCell>
                              <TableCell
                                className={classes.tablheader}
                                sx={{ textAlign: "end" }}
                              >
                                <strong className={classes.cardTitle}>
                                  Action{" "}
                                </strong>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {Array.isArray(relativeData?.data) ? (
                              relativeData?.data.map(
                                (customer: ICustomerRelative) => (
                                  <TableRow key={customer.id}>
                                    <TableCell>
                                      {cutomerMap.get(
                                        customer.related_customer_id
                                      )}
                                    </TableCell>
                                    <TableCell>
                                      {customer.relationship_type}
                                    </TableCell>
                                    <TableCell>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            onClick={() =>
                                              handleSelectCustomer(customer)
                                            }
                                            disabled={
                                              typeof customer.id === "number" &&
                                              selectedCustomerIds.includes(
                                                customer.id
                                              )
                                            }
                                          >
                                            Select
                                          </Button>
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  </TableRow>
                                )
                              )
                            ) : (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  No clients found
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    )}
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleCloseDialog}
                    >
                      Close
                    </Button>
                    <Box m={0.5}></Box>
                    <Button
                      variant="contained"
                      className={classes.addButton}
                      onClick={handleCloseDialog}
                    >
                      Update
                    </Button>
                  </Grid>
                </Grid>
                {openAddProject && (
                  <NewPopUpRelative
                    openModel={openAddProject}
                    handleCloseDialog={handleCloseDialogRelative}
                    // data={coursings}
                    customerClientId={String(customerId)}
                  />
                )}
              </Dialog> */}

              <Dialog
                open={openDialogJoin}
                onClose={handleCloseDialogJoin}
                aria-describedby="alert-dialog-description"
                classes={{ paper: "inherit" }}
                fullScreen={isMobile}
                fullWidth={isMobile}
                maxWidth="lg"
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography className={classes.cardTitle}>
                      Search Existing Client (Joint Policy Owner)
                    </Typography>

                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleCloseDialogJoin}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>

                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                    padding={2}
                  >
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile & Name .."
                      sx={{ width: "100%", maxWidth: "400px" }}
                      size="small"
                    />

                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={() => {
                        setSelectedCoursing(undefined);
                        setOpenDialogAddProduct(true);
                      }}
                    >
                      Add Client
                    </Button>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      padding={2}
                    >
                      {customerIsLoading ? (
                        <CircularProgress />
                      ) : (
                        <TableContainer>
                          <Table>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    Client Name{" "}
                                  </strong>
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    Mobile Number{" "}
                                  </strong>
                                </TableCell>{" "}
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    E-mail Address{" "}
                                  </strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  <strong className={classes.cardTitle}>
                                    Action{" "}
                                  </strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Array.isArray(searchResults?.data) ? (
                                searchResults?.data.map(
                                  (customer: ICustomer) => (
                                    <TableRow key={customer.id}>
                                      <TableCell>{`${customer.customerFirstName} ${customer.customerLastName}`}</TableCell>
                                      <TableCell>
                                        {customer.customerMobileNum || ""}
                                      </TableCell>
                                      <TableCell>
                                        {customer.customerEmail?.toLowerCase() ||
                                          ""}
                                      </TableCell>
                                      <TableCell>
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Grid item>
                                            <Button
                                              variant="contained"
                                              className={classes.addButton}
                                              onClick={() =>
                                                handleSelectCustomerJoin(
                                                  customer
                                                )
                                              }
                                            >
                                              Select
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={6}>
                                    No clients found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleCloseDialogJoin}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Dialog>

              <Dialog
                open={openDialogCont}
                onClose={handleCloseDialoCont}
                aria-describedby="alert-dialog-description"
                classes={{ paper: "inherit" }}
                fullScreen={isMobile}
                fullWidth={isMobile}
                maxWidth="lg"
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography className={classes.cardTitle}>
                      Search Existing Client (Contengent Policy Owner)
                    </Typography>

                    <Button
                      variant="contained"
                      className={classes.editButton}
                      onClick={handleCloseDialoCont}
                    >
                      <CloseIcon />
                    </Button>
                  </Grid>

                  <Grid
                    container
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    alignItems="center"
                    justifyContent="space-between"
                    padding={2}
                  >
                    <TextField
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CiSearch className={classes.searchWidgetIcon} />
                          </InputAdornment>
                        ),
                        classes: {
                          root: classes.formControlList,
                        },
                      }}
                      fullWidth
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      placeholder="Mobile & Name .."
                      sx={{ width: "100%", maxWidth: "400px" }}
                      size="small"
                    />

                    <Button
                      // variant="contained"
                      className={classes.addNewButton}
                      onClick={() => {
                        setSelectedCoursing(undefined);
                        setOpenDialogAddProduct(true);
                      }}
                    >
                      Add Client
                    </Button>
                  </Grid>

                  <Grid item lg={12} md={12} sm={12} xs={12} pb={3}>
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      padding={2}
                    >
                      {customerIsLoading ? (
                        <CircularProgress />
                      ) : (
                        <TableContainer>
                          <Table>
                            <TableHead className={classes.tableHeaderRow}>
                              <TableRow>
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    Client Name{" "}
                                  </strong>
                                </TableCell>
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    Mobile Number{" "}
                                  </strong>
                                </TableCell>{" "}
                                <TableCell className={classes.tablheader}>
                                  <strong className={classes.cardTitle}>
                                    E-mail Address{" "}
                                  </strong>
                                </TableCell>
                                <TableCell
                                  className={classes.tablheader}
                                  sx={{ textAlign: "end" }}
                                >
                                  <strong className={classes.cardTitle}>
                                    Action{" "}
                                  </strong>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {Array.isArray(searchResults?.data) ? (
                                searchResults?.data.map(
                                  (customer: ICustomer) => (
                                    <TableRow key={customer.id}>
                                      <TableCell>{`${customer.customerFirstName} ${customer.customerLastName}`}</TableCell>
                                      <TableCell>
                                        {customer.customerMobileNum || ""}
                                      </TableCell>
                                      <TableCell>
                                        {customer.customerEmail?.toLowerCase() ||
                                          ""}
                                      </TableCell>
                                      <TableCell>
                                        <Grid
                                          container
                                          spacing={1}
                                          sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          <Grid item>
                                            <Button
                                              variant="contained"
                                              className={classes.addButton}
                                              onClick={() =>
                                                handleSelectCustomerCont(
                                                  customer
                                                )
                                              }
                                            >
                                              Select
                                            </Button>
                                          </Grid>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={6}>
                                    No clients found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      )}
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Button
                      variant="outlined"
                      className={classes.addButton}
                      onClick={handleCloseDialoCont}
                    >
                      Close
                    </Button>
                  </Grid>
                </Grid>
              </Dialog>
            </Grid>
          </Grid>
        </Grid>
        {openDialogAddProduct && (
          <NewPopUpProduct
            openModel={openDialogAddProduct}
            handleCloseDialog={() => setOpenDialogAddProduct(false)}
            data={selectedCoursing}
          />
        )}

        {openCategory && (
          <NewCategoryPopUp
            handleCloseDialog={() => setOpenCategory(false)}
            openModel={openCategory}
          />
        )}

        {openProductBrand && (
          <NewProductBrand
            handleCloseDialog={() => setOpenProductBrand(false)}
            openModel={openProductBrand}
          />
        )}

        {openProduct && (
          <NewProductPopUp
            handleCloseDialog={() => setOpenProduct(false)}
            openModel={openProduct}
          />
        )}
      </form>
    </div>
  );
};

export default Index;
